import { render, staticRenderFns } from "./BrightbackKeep.vue?vue&type=template&id=388b588a&"
import script from "./BrightbackKeep.vue?vue&type=script&lang=js&"
export * from "./BrightbackKeep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports